import React from 'react';

const Dashboard = ({user, secret}) => {
  return <div>Dashboard</div>;
};
export default Dashboard